import React, { Component } from "react";
import * as echarts from "echarts/dist/echarts.js";
import "bootstrap/dist/css/bootstrap.css";
import "./dashboard.css";
import {
  getSystemRealTimeData,
  getSystemLatestData,
  getSystemBasics,
  ws_getSystemLatestData,
  getSystemInfo,
} from "../services/systemService";

import { webSocketMode } from "../config.json"; //0: http; 1:websocket

class LineGraph2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      graphLen: 0,
      base: new Date(),
      oneDay: 86400000,
      date: [],
      value1: [0],
      value2: [0],
      value3: [0],
      value4: [0],
      now: new Date(),
    };
  }

  async componentDidMount() {
    if (this.props.chartDateInitial) {
      this.setState({
        date: this.props.chartDateInitial,
        value1: this.props.chartValue1Initial,
        value2: this.props.chartValue2Initial,
        value3: this.props.chartValue3Initial,
        value4: this.props.chartValue4Initial,
      });
    }
    this.chart = echarts.init(document.getElementById("graph-area2"));
    //console.log("Tick Number", tickNumber);
    const tickNumber = 1000;
    this.timerID = setInterval(() => this.tick(), tickNumber);
    this.generateGraph();
  }

  componentDidUpdate(prevProps) {
    if (!this.chart) return;

    if (
      this.props.modeBox === "Real-time" &&
      prevProps.modeBox !== "Real-time"
    ) {
      this.resetRealtimeWindow();
      return;
    }

    this.chart.setOption({
      xAxis: { data: this.state.date },
      series: [
        { data: this.state.value1 },
        { data: this.state.value2 },
        { data: this.state.value3 },
        { data: this.state.value4 },
        // { data: this.state.value5 },
      ],
    });
  }

  resetRealtimeWindow() {
    this.setState({
      date: [],
      value1: [],
      value2: [],
      value3: [],
      value4: [],
      // value5: [],
    });

    this.chart.setOption({
      xAxis: { data: [] },
      series: [
        { data: [] },
        { data: [] },
        { data: [] },
        { data: [] },
        // { data: [] },
      ],
    });
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  // ------ ORIGINAL REAL-TIME UPDATE METHOD--------------------------------------
  // tick() {
  //   this.addData(false);
  //   this.chart.setOption({
  //     yAxis: {
  //       max: 2.1,
  //     },
  //     xAxis: {
  //       data: this.state.date,
  //       axisTick: { show: false },
  //       splitLine: { show: false },
  //     },

  //     series: [
  //       {
  //         name: `${this.props.chartLegend1}`,
  //         data: this.state.value1,
  //       },
  //       {
  //         name: `${this.props.chartLegend2}`,
  //         data: this.state.value2,
  //       },
  //       {
  //         name: `${this.props.chartLegend3}`,
  //         data: this.state.value3,
  //       },
  //       {
  //         name: `${this.props.chartLegend4}`,
  //         data: this.state.value4,
  //       },
  //     ],
  //   });
  // }
  // ------ MODIFIED REAL-TIME UPDATE METHOD--------------------------------------
  tick() {
    if (!this.props.playPause) return;

    const now = new Date();
    const nowStr = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;

    this.setState(
      (prev) => {
        const newDate = prev.date.concat(nowStr);
        const newValue1 = prev.value1.concat(this.props.chartValue1);
        const newValue2 = prev.value2.concat(this.props.chartValue2);
        const newValue3 = prev.value3.concat(this.props.chartValue3);
        const newValue4 = prev.value4.concat(this.props.chartValue4);

        const pointsOnChart = parseInt(localStorage.getItem("pointsOnChart"));
        const delta = newValue1.length - pointsOnChart;

        if (delta > 0 && this.props.modeBox === "Real-time") {
          return {
            date: newDate.slice(delta),
            value1: newValue1.slice(delta),
            value2: newValue2.slice(delta),
            value3: newValue3.slice(delta),
            value4: newValue4.slice(delta),
          };
        }

        return {
          date: newDate,
          value1: newValue1,
          value2: newValue2,
          value3: newValue3,
          value4: newValue4,
        };
      },
      () => {
        this.chart.setOption({
          xAxis: { data: this.state.date },
          series: [
            { data: this.state.value1 },
            { data: this.state.value2 },
            { data: this.state.value3 },
            { data: this.state.value4 },
          ],
        });
      },
    );
  }
  // ----------------------------------------------------------
  addData(shift) {
    this.state.now = [
      this.state.now.getHours(),
      this.state.now.getMinutes(),
      this.state.now.getSeconds(),
    ].join(":");

    if (this.props.playPause) {
      this.state.date.push(this.state.now);

      if (this.props.chartDateInitial) {
        this.state.value1.push(this.props.chartValue1);
        this.state.value2.push(this.props.chartValue2);
        this.state.value3.push(this.props.chartValue3);
        this.state.value4.push(this.props.chartValue4);
      }
    }
    const stringLength = parseInt(this.state.value1.length);
    const pointsOnChart = parseInt(localStorage.getItem("pointsOnChart"));

    const delta = stringLength - pointsOnChart;

    if (delta > 0 && this.props.modeBox === "Real-time") {
      this.state.date.shift();
      this.state.value1.shift();
      this.state.value2.shift();
      this.state.value3.shift();
      this.state.value4.shift();
    }
    this.state.now = new Date();
  }
  generateGraph() {
    var option = {
      grid: {
        top: 10,
        bottom: 20,
        left: "10%",
        right: "10%",
      },
      /*  legend: {
        type: "scroll",
        data: [
          `${this.props.chartLegend1}`,
          `${this.props.chartLegend2}`,
          `${this.props.chartLegend3}`,
          `${this.props.chartLegend4}`,
        ],
        center: "50%",
        top: "0%",
        orient: "horizontal",
        align: "auto",
        padding: 3,
        textStyle: {
          fontStyle:
            "normal" ,
          fontSize: 10,
          fontWeight: "bold",
          color: "grey",
        },
        backgroundColor: "transparent",
        borderColor: "#ffffff",
        borderWidth: 1,
        boarderRadius: 0,
      },*/
      legend: {
        show: false,
      },
      xAxis: {
        name: "",
        nameLocation: "end",
        type: "category",
        nameTextStyle: {
          fontStyle:
            "normal" /*'Lato,"Helvetica Neue",Arial,Helvetica,sans-serif'*/,
          fontSize: 16,
          fontWeight: "bolder",
          color: "green",
        },
        axisLabel: {
          fontStyle: "normal",
          fontSize: 8,
          fontWeight: "normal",
          color: "orange",
        },
        boundaryGap: false,
        data: this.state.date,
      },
      yAxis: {
        show: false,
        name: "Power (Watts)",
        nameLocation: "end",
        boundaryGap: [0, "10%"],
        type: "value",
        max: 2.1,
        nameTextStyle: {
          fontStyle:
            "normal" /*'Lato,"Helvetica Neue",Arial,Helvetica,sans-serif'*/,
          fontSize: 16,
          fontWeight: "bolder",
          color: "orange",
        },
        axisLabel: {
          fontStyle: "normal",
          fontSize: 8,
          fontWeight: "normal",
          color: "orange",
        },
      },
      // tooltip: {
      //   trigger: "axis",
      //   axisPointer: {
      //     type: "cross",
      //     animation: false,
      //     label: {
      //       backgroundColor: "#6a7985",
      //       precision: 2,
      //     },
      //   },
      // },

      /* dataZoom: [
        {
          type: "slider",
          show: true,
          xAxisIndex: [0],
          start: 1,
          end: 100,
        },
        {
          type: "inside",
          xAxisIndex: [0],
          start: 1,
          end: 100,
        },
      ],*/
      series: [
        {
          name: "PV Power",
          type: "line",
          symbol: "none",
          color: "dodgerblue",
          smooth: 0.25,
          areaStyle: {
            normal: {
              color: "dodgerblue",
            },
          },
          data: this.state.value1,
        },
        {
          name: "Battery Power",
          type: "line",
          symbol: "none",
          color: "blue",
          smooth: 0.25,
          /*areaStyle: {
            normal: { color: "DodgerBlue" },
          },*/
          data: this.state.value2,
        },
        {
          name: "Grid Power",
          type: "line",
          symbol: "none",
          color: "tomato",
          smooth: 0.25,
          areaStyle: {
            normal: {
              color: "tomato",
            },
          },
          data: this.state.value3,
        },
        {
          name: "Building Power",
          type: "line",
          symbol: "none",
          color: "red",
          smooth: 0.25,
          data: this.state.value4,
          label: {
            show: true,
            value: "kW",
          },
        },
      ],
      /*tooltip: {
        trigger: "axis",
        axisPointer: {
          animation: false,
          type: "cross",
          label: {
            backgroundColor: "#6a7985",
            precision: "2",
          },
        },
      },*/
    };

    this.chart.setOption(option);
  }

  render() {
    return <div id="graph-area2" styles={{ width: "100%", height: "300px" }} />;
  }
}
export default LineGraph2;

// import React, { Component } from "react";
// import * as echarts from "echarts/dist/echarts.js";
// import "bootstrap/dist/css/bootstrap.css";
// import "./dashboard.css";

// class LineGraph2 extends Component {
//   constructor(props) {
//     super(props);

//     this.chart = null;
//     this.timerID = null;

//     this.state = {
//       date: [],
//       value1: [],
//       value2: [],
//       value3: [],
//       value4: [],
//       now: new Date(),
//     };

//     // MATCH LineGraph COLORS
//     this.colors = {
//       pv: "orange",
//       battery: "DodgerBlue",
//       grid: "magenta",
//       building: "green",
//     };
//   }

//   componentDidMount() {
//     if (this.props.chartDateInitial) {
//       this.setState({
//         date: this.props.chartDateInitial,
//         value1: this.props.chartValue1Initial,
//         value2: this.props.chartValue2Initial,
//         value3: this.props.chartValue3Initial,
//         value4: this.props.chartValue4Initial,
//       });
//     }

//     this.chart = echarts.init(document.getElementById("graph-area2"));
//     this.generateGraph();

//     this.timerID = setInterval(() => this.tick(), 1000);
//   }

//   componentWillUnmount() {
//     clearInterval(this.timerID);
//     if (this.chart) this.chart.dispose();
//   }

//   //----------------------------------------------------------
//   //  REAL-TIME UPDATE
//   //----------------------------------------------------------
//   tick() {
//     this.addData();

//     this.chart.setOption({
//       xAxis: {
//         data: this.state.date,
//       },
//       series: [
//         { data: this.state.value1 },
//         { data: this.state.value2 },
//         { data: this.state.value3 },
//         { data: this.state.value4 },
//       ],
//     });
//   }

//   //----------------------------------------------------------
//   //  PUSH REAL-TIME DATA
//   //----------------------------------------------------------
//   addData() {
//     const nowLabel = [
//       this.state.now.getHours(),
//       this.state.now.getMinutes(),
//       this.state.now.getSeconds(),
//     ].join(":");

//     if (this.props.playPause) {
//       this.state.date.push(nowLabel);

//       this.state.value1.push(this.props.chartValue1);
//       this.state.value2.push(this.props.chartValue2);
//       this.state.value3.push(this.props.chartValue3);
//       this.state.value4.push(this.props.chartValue4);
//     }

//     const pointsOnChart = parseInt(localStorage.getItem("pointsOnChart"));
//     const delta = this.state.value1.length - pointsOnChart;

//     if (delta > 0 && this.props.modeBox === "Real-time") {
//       this.state.date.shift();
//       this.state.value1.shift();
//       this.state.value2.shift();
//       this.state.value3.shift();
//       this.state.value4.shift();
//     }

//     this.state.now = new Date();
//   }

//   //----------------------------------------------------------
//   //  INITIAL GRAPH (MATCH LineGraph)
//   //----------------------------------------------------------
//   generateGraph() {
//     const option = {
//       color: [
//         this.colors.pv,
//         this.colors.battery,
//         this.colors.grid,
//         this.colors.building,
//       ],

//       tooltip: {
//         trigger: "axis",
//         axisPointer: {
//           type: "cross",
//           animation: false,
//           label: {
//             backgroundColor: "#6a7985",
//             precision: "2",
//           },
//         },
//         hideDelay: 800,
//       },

//       legend: {
//         show: false, // REAL-TIME MATCH
//       },

//       grid: {
//         top: 30,
//         bottom: 40,
//         left: "8%",
//         right: "8%",
//       },

//       xAxis: {
//         type: "category",
//         boundaryGap: false,
//         data: this.state.date,
//         axisLabel: {
//           fontSize: 8,
//           color: "orange",
//         },
//         axisTick: { show: true },
//         splitLine: { show: true },
//       },

//       yAxis: {
//         show: false,
//         type: "value",
//         max: 2.1,
//       },

//       series: [
//         {
//           name: this.props.chartLegend1,
//           type: "line",
//           symbol: "none",
//           smooth: 0.25,
//           lineStyle: { width: 2 },
//           data: this.state.value1,
//         },
//         {
//           name: this.props.chartLegend2,
//           type: "line",
//           symbol: "none",
//           smooth: 0.25,
//           lineStyle: { width: 2 },
//           data: this.state.value2,
//         },
//         {
//           name: this.props.chartLegend3,
//           type: "line",
//           symbol: "none",
//           smooth: 0.25,
//           lineStyle: { width: 2 },
//           data: this.state.value3,
//         },
//         {
//           name: this.props.chartLegend4,
//           type: "line",
//           symbol: "none",
//           smooth: 0.25,
//           lineStyle: { width: 2 },
//           data: this.state.value4,
//         },
//       ],
//     };

//     this.chart.setOption(option, true);
//   }

//   render() {
//     return <div id="graph-area2" />;
//   }
// }

// export default LineGraph2;
